import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TimeService, TimeDataType } from '../../services/time.service';
import { ContextService } from '../../services/context.service';


@Component({
  selector: 'app-year-selector',
  templateUrl: './year-selector.component.html',
  styleUrls: ['./year-selector.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class YearSelectorComponent implements OnInit {

  years: number[] = [];
  constructor(private time: TimeService, private app: ContextService) { }

  ngOnInit() {
    this.time.get().then((t) => {
      this.years = t.valueMap.map(v => v.year).filter((v, i, r) => r.indexOf(v) === i);
      this.time.graphYear = this.years[0];
    });
  }

  yearChanged(event: { target: { value: string } }) {
    this.time.graphYear = parseInt(event.target.value, 10);
    this.app.graphYearUpdated();
  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/year-selector/year-selector.component.ts